module.exports = __webpack_public_path__ + "img/alcoholMJ.bc503ef9.png";